/* tslint:disable */
/* eslint-disable */
/**
 * re-order
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BatchItem } from './BatchItem';
import {
    BatchItemFromJSON,
    BatchItemFromJSONTyped,
    BatchItemToJSON,
} from './BatchItem';
import type { SerialItem } from './SerialItem';
import {
    SerialItemFromJSON,
    SerialItemFromJSONTyped,
    SerialItemToJSON,
} from './SerialItem';

/**
 * 
 * @export
 * @interface Article
 */
export interface Article {
    /**
     * 
     * @type {string}
     * @memberof Article
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Article
     */
    externalId?: string;
    /**
     * 
     * @type {string}
     * @memberof Article
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof Article
     */
    title?: string;
    /**
     * 
     * @type {number}
     * @memberof Article
     */
    quantity?: number;
    /**
     * 
     * @type {string}
     * @memberof Article
     */
    quantityUnit?: string;
    /**
     * 
     * @type {number}
     * @memberof Article
     */
    quantityBooked?: number;
    /**
     * 
     * @type {string}
     * @memberof Article
     */
    type?: ArticleTypeEnum;
    /**
     * 
     * @type {Array<BatchItem>}
     * @memberof Article
     */
    batchItems?: Array<BatchItem>;
    /**
     * 
     * @type {Array<SerialItem>}
     * @memberof Article
     */
    serialItems?: Array<SerialItem>;
    /**
     * 
     * @type {boolean}
     * @memberof Article
     */
    isSelected?: boolean;
}


/**
 * @export
 */
export const ArticleTypeEnum = {
    Default: 'DEFAULT',
    Batch: 'BATCH',
    Serial: 'SERIAL',
    UnknownDefaultOpenApi: '11184809'
} as const;
export type ArticleTypeEnum = typeof ArticleTypeEnum[keyof typeof ArticleTypeEnum];


/**
 * Check if a given object implements the Article interface.
 */
export function instanceOfArticle(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ArticleFromJSON(json: any): Article {
    return ArticleFromJSONTyped(json, false);
}

export function ArticleFromJSONTyped(json: any, ignoreDiscriminator: boolean): Article {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'externalId': !exists(json, 'externalId') ? undefined : json['externalId'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'quantity': !exists(json, 'quantity') ? undefined : json['quantity'],
        'quantityUnit': !exists(json, 'quantityUnit') ? undefined : json['quantityUnit'],
        'quantityBooked': !exists(json, 'quantityBooked') ? undefined : json['quantityBooked'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'batchItems': !exists(json, 'batchItems') ? undefined : ((json['batchItems'] as Array<any>).map(BatchItemFromJSON)),
        'serialItems': !exists(json, 'serialItems') ? undefined : ((json['serialItems'] as Array<any>).map(SerialItemFromJSON)),
        'isSelected': !exists(json, 'isSelected') ? undefined : json['isSelected'],
    };
}

export function ArticleToJSON(value?: Article | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'externalId': value.externalId,
        'description': value.description,
        'title': value.title,
        'quantity': value.quantity,
        'quantityUnit': value.quantityUnit,
        'quantityBooked': value.quantityBooked,
        'type': value.type,
        'batchItems': value.batchItems === undefined ? undefined : ((value.batchItems as Array<any>).map(BatchItemToJSON)),
        'serialItems': value.serialItems === undefined ? undefined : ((value.serialItems as Array<any>).map(SerialItemToJSON)),
        'isSelected': value.isSelected,
    };
}

